import { render } from "./MemberAddPage.vue?vue&type=template&id=2efa1c1d"
import script from "./MemberAddPage.vue?vue&type=script&lang=js"
export * from "./MemberAddPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__